angular.module('clients')
    .directive('clientEmailPicker', function ($filter, $document, $compile, $parse, Client) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: true,
            scope: {
                clients: '=',
                additionalEmails: '=?'
            },
            templateUrl: "app/clients/client-email-picker/client-email-picker.tpl.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {

                scope.inputSwitch = false;
                refreshClientContacts(scope.clients);

                scope.$watchCollection(() => scope.clients, (newValue, oldValue) => {
                    if (oldValue !== newValue || oldValue === null) {
                        refreshClientContacts(scope.clients);
                    }
                });

                scope.$watchCollection(() => scope.additionalEmails, () => {
                    refreshClientContacts(scope.clients);
                });

                function refreshClientContacts(clients) {
                    scope.clientContacts = [];
                    addAdditionalEmails(scope.additionalEmails);

                    angular.forEach(clients, client => {
                        if (!client || !client.id) {
                            return;
                        }
                        Client.contacts({id: client.id}).$promise.then(items => {
                            (items || []).forEach(singleContact => {
                                if (singleContact && singleContact.type === 'EMAIL' && singleContact.value && singleContact.value.length > 0) {
                                    addContactOption({
                                        key: "contact-email-" + (singleContact.id || (client.id + "-" + singleContact.value)),
                                        label: singleContact.name || singleContact.value,
                                        value: singleContact.value,
                                        group: "Kontakt"
                                    });
                                }
                            });
                        });
                    });
                }

                function addAdditionalEmails(emails) {
                    angular.forEach([].concat(emails || []), email => {
                        if (!email || email.length === 0) {
                            return;
                        }
                        addContactOption({
                            key: "additional-email-" + email,
                            label: email,
                            value: email,
                            group: "Lead"
                        });
                    });
                }

                function addContactOption(option) {
                    if (!option || !option.value || scope.clientContacts.some(item => item.value === option.value)) {
                        return;
                    }
                    scope.clientContacts.push(option);
                }

                scope.onSelect = ($item, $model) => {
                    scope.text = $item.value;
                    scope.inputSwitch = false;
                    delete scope.uiNgModel;
                };

                scope.switchInput = bool => scope.inputSwitch = bool;

                // ngModelCtrl.$isEmpty = function (modelValue) {
                //     return !angular.isArray(modelValue) || modelValue.length === 0;
                // };
                ngModelCtrl.$render = () => scope.text = ngModelCtrl.$viewValue;
                ngModelCtrl.$formatters.push(modelValue => modelValue);
                ngModelCtrl.$parsers.push(viewValue => viewValue);
                ngModelCtrl.$validators.isValidState = (modelValue, viewValue) => !scope.inputSwitch;

                scope.$watch('text + inputSwitch', () => {
                    ngModelCtrl.$setViewValue(scope.text);
                    ngModelCtrl.$validate();
                    ngModelCtrl.$render();
                });
            }
        };
    });
